import { Box, Chip, Typography } from '@mui/material'

import ToothGraphic4 from '@/assets/images/Tooth-graphic-4.svg'
import PieChart from '@/components/PieChart'

const DentinLayerAdvice = ({
  recipe,
  dentinCervicalIndex,
  dentinMiddleIndex,
  dentinIncisalIndex,
}) => {
  const isNullorEmpty = (data, ...keys) =>
    keys.reduce((obj, key) => obj?.[key], data) ?? null

  const renderSection = (title, data, index) => (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="150px"
      mx={1}
      color="black"
    >
      {/* Layer 1 */}
      {data?.recipe_layer1?.[index] && (
        <>
          <Typography
            sx={{ color: 'black', fontWeight: 'bold', textAlign: 'center' }}
          >
            {title}
          </Typography>
          {isNullorEmpty(
            data,
            'recipe_layer1',
            `${index}`,
            'opacity_category',
          ) && (
            <Typography
              align="center"
              textTransform="capitalize"
              sx={{ fontWeight: 'bold', color: 'black' }}
            >
              {data.recipe_layer1[index].opacity_category}
            </Typography>
          )}
          <PieChart
            labels={data.recipe_layer1[index].powders}
            values={data.recipe_layer1[index].simplified_ratios}
          />
        </>
      )}

      {/* Layer 2 */}
      {data?.recipe_layer2?.[index] && (
        <>
          {isNullorEmpty(
            data,
            'recipe_layer2',
            `${index}`,
            'opacity_category',
          ) && (
            <Typography
              align="center"
              textTransform="capitalize"
              sx={{ fontWeight: 'bold', color: 'black' }}
            >
              {data.recipe_layer2[index].opacity_category}
            </Typography>
          )}
          <PieChart
            labels={data.recipe_layer2[index].powders}
            values={data.recipe_layer2[index].simplified_ratios}
          />
        </>
      )}
    </Box>
  )

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      flexGrow={1}
      px={5}
      sx={{ backgroundColor: '#FFF' }}
      id="download-page-2"
    >
      {recipe.dentinlayer_advice && (
        <Box display="flex" alignItems="center">
          {/* Left Section */}
          <Box display="flex" width="30%">
            <img
              src={ToothGraphic4}
              alt="Toothimage"
              style={{ width: 233, height: 330 }}
            />
          </Box>

          {/* Right Section */}
          <Box width="70%">
            <Box display="flex" alignItems="center" m={2}>
              <Typography variant="h5" sx={{ color: 'black' }}>
                Dentin:
              </Typography>
              {isNullorEmpty(recipe, 'provided_input', 'brand') && (
                <Chip
                  label={recipe.provided_input.brand}
                  sx={{
                    backgroundColor: '#F44336',
                    color: '#FFF',
                    borderRadius: '16px',
                    ml: 2,
                  }}
                />
              )}
            </Box>

            {/* Pie Charts - Horizontal Layout */}
            <Box display="flex" justifyContent="center" gap={8}>
              {renderSection(
                'Cervical',
                recipe.dentinlayer_advice?.dentinrecipes_cervical,
                dentinCervicalIndex,
              )}
              {renderSection(
                'Middle',
                recipe.dentinlayer_advice?.dentinrecipes_middle,
                dentinMiddleIndex,
              )}
              {renderSection(
                'Incisal',
                recipe.dentinlayer_advice?.dentinrecipes_incisal,
                dentinIncisalIndex,
              )}
            </Box>

            {/* Divider */}
            <Box
              sx={{
                height: '1px',
                backgroundColor: 'black',
                opacity: 1,
                mt: 2,
                mb: 2,
              }}
            />
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default DentinLayerAdvice
